export type AssistantHealth = {
    ok: true;
    scope: string;
};

/** Mirrors `apps/assistant/contracts/assistant-admin.ts`. Kept by hand. */
export const CONFIG_FIELD_MAX_LENGTH = 4000;

export type AssistantConfigPayload = {
    behaviour: string | null;
    topicGuidance: string | null;
};

export const PAGE_TEXT_MAX_LENGTH = 2000;

export type PageKnowledgeEntry = {
    slug: string;
    title: string;
    route: string;
    text: string | null;
    hasText: boolean;
};

export type QuestionFunnel = 'info' | 'product' | 'booking';
export const QUESTION_FUNNELS: readonly QuestionFunnel[] = [
    'info',
    'product',
    'booking',
];

export const QUESTION_LABEL_MAX_LENGTH = 120;

export type PredefinedQuestionRecord = {
    id: string;
    labelDe: string;
    labelEn: string;
    funnel: QuestionFunnel;
    requiresLogin: boolean;
    sortIndex: number;
    enabled: boolean;
};

// `liftOperatorId` is what decides this, not a separate surface flag — a
// widget chat with no selected operator is still portal-scoped.
export type ChatOrigin =
    { kind: 'portal' } | { kind: 'operator'; liftOperatorId: string };

export type ChatListItem = {
    id: string;
    title: string | null;
    user: string | null;
    origin: ChatOrigin;
    locale: string | null;
    messageCount: number;
    feedbackScore: number | null;
    createdAt: string;
    lastTurnAt: string;
};

export type ChatListPage = {
    items: ChatListItem[];
    total: number;
};

export const CHAT_PAGE_SIZE_DEFAULT = 25;
export const CHAT_PAGE_SIZE_MAX = 100;

export type ChatMessageRecord = {
    id: string;
    role: string;
    content: string;
    seq: number;
    createdAt: string;
};

export type ChatDetail = ChatListItem & {
    messages: ChatMessageRecord[];
    feedbackComment: string | null;
    bugReportCount: number;
};

/** Mirrors `PRODUCT_TEXT_MAX_LENGTH` in `apps/assistant/contracts/assistant-admin.ts`. */
export const PRODUCT_TEXT_MAX_LENGTH = 1000;

/** `productId` is Starjack's `shortProductId` — the admin's `productId`. */
export type ProductTextPayload = {
    productId: string;
    text: string;
    updatedAt: string | null;
};
